import { useEffect, useState, useMemo } from "react";
import { Dialog, Toast, Loading } from "@xp-design/mobile";
import { getChannel } from "@/utils/tools";
import { receivePrize } from "@/api/configPage.ts";
import {
  enhancedSafeChainFind,
  getValueByKey,
  renderStyle,
} from "@/pages/par-marketing/configPage/utils";
import "./index.less";
import icon_right from "@/assets/icon_right.png";
import { trackGdp } from "@/utils/gio-report";
import { goToPageV2 } from "@/utils/common";
import FontSetBox from "@/component/fontSetBox";
import { useConfigPage } from "@/hooks/useConfigPage/useConfigPage";
import { processOssImage } from "@/utils/image";

// 阶梯组件
const Stairs = (props) => {
  const { stairInfo, initialStatusInfo = {}, getDetail = () => {} } = props;
  const { ensureLogin, isGuest } = useConfigPage();
  const [rewardDialogVisible, setRewardDialogVisible] = useState(false);
  const [showDialogData, setShowDialogData] = useState({
    isSuccess: false,
    prizeList: [],
  });

  const [twoValDialogData, setTwoValDialogData] = useState({
    item: {},
    index: 0,
    node_status: "",
    canClaim: false,
  });

  // 将statusInfo转换为组件内部状态
  const [statusInfo, setStatusInfo] = useState(initialStatusInfo);

  // 监听initialStatusInfo变化，自动更新statusInfo状态
  useEffect(() => {
    setStatusInfo(initialStatusInfo);
  }, [initialStatusInfo]);

  const reActivity = useMemo(() => {
    const result = enhancedSafeChainFind(stairInfo.moduleJsonData)?.base(
      "type",
      "reActivity",
    )?.val;
    return result || stairInfo?.moduleJsonData?.base?.[0];
  }, [stairInfo]);

  const configTabs = useMemo(() => {
    const result = enhancedSafeChainFind(stairInfo.moduleJsonData)?.base(
      "type",
      "configTabs",
    )?.val;
    return result || stairInfo?.moduleJsonData?.base?.[2];
  }, [stairInfo]);

  // 要展示的图片合集
  const stairImgMap = useMemo(() => {
    const imgMap = {};
    configTabs[configTabs.val]?.map((imgArr, index) => {
      if (index === 0) {
        // 第0个事背景图片
        imgArr.map((item) => {
          imgMap[item.icon] = {
            name: item.name,
            src: item.src,
          };
        });
      }
    });
    return imgMap;
  }, [configTabs]);

  const configActivity = useMemo(() => {
    const result = enhancedSafeChainFind(stairInfo.moduleJsonData)?.base(
      "type",
      "configActivity",
    )?.val;
    return result || stairInfo?.moduleJsonData?.base?.[1];
  }, [stairInfo]);

  // 风格：oneVal twoVal
  const stairsStyle = useMemo(() => {
    return configActivity?.val?.activityStyle;
  }, [configActivity]);

  const oneVal = useMemo(() => {
    return configTabs?.oneVal;
  }, [configTabs]);

  const twoVal = useMemo(() => {
    return configTabs?.twoVal;
  }, [configTabs]);

  const showElement = useMemo(() => {
    const result = enhancedSafeChainFind(stairInfo.moduleJsonData)?.base(
      "configActivity",
    )?.val?.val?.showElement;
    return result || null;
  }, [stairInfo]);

  const showConfig = (key) => {
    console.log("showElement", showElement);
    const enums = {
      masterTitle: "1",
      activityDetail: "2",
    };
    if (showElement) {
      return showElement?.includes(enums[key]);
    }
    return true;
  };

  // 文案风格样式列表
  const styleList = useMemo(() => {
    return oneVal?.[2]?.[0]?.options?.map((item) => {
      item.styleObject = renderStyle(item.styleData); // 生成style对象
      return item;
    });
  }, [oneVal]);

  const styleList2 = useMemo(() => {
    return twoVal?.[3]?.[0]?.options?.map((item) => {
      item.styleObject = renderStyle(item.styleData); // 生成style对象
      return item;
    });
  }, [twoVal]);

  const rankBg2 = useMemo(() => {
    return getValueByKey(twoVal?.[0], "key", "rankBg2")?.src;
  }, [twoVal]);

  const completedColor = useMemo(() => {
    return getValueByKey(twoVal?.[0], "key", "completedColor")?.val;
  }, [twoVal]);

  const jlcgtk001 = useMemo(() => {
    return getValueByKey(twoVal?.[2], "key", "jlcgtk001")?.src;
  }, [configActivity]);

  const jlcktk001 = useMemo(() => {
    return getValueByKey(twoVal?.[2], "key", "jlcktk001")?.src;
  }, [configActivity]);

  const uncompletedColor = useMemo(() => {
    return getValueByKey(twoVal?.[0], "key", "uncompletedColor")?.val;
  }, [twoVal]);

  const currentColor = useMemo(() => {
    return getValueByKey(twoVal?.[0], "key", "currentColor")?.val;
  }, [twoVal]);

  const accumulateTipColor = useMemo(() => {
    return getValueByKey(twoVal?.[0], "key", "accumulateTip")?.val;
  }, [twoVal]);

  const nodeArrow = useMemo(() => {
    return getValueByKey(twoVal?.[0], "key", "nodeArrow")?.src;
  }, [twoVal]);

  const multiplePrize = useMemo(() => {
    return getValueByKey(twoVal?.[0], "key", "multiplePrize")?.src;
  }, [twoVal]);

  const bgImg = useMemo(() => {
    return getValueByKey(twoVal?.[1], "key", "activityDetail")?.src;
  }, [twoVal]);

  // 领取按钮
  const receiveImg = useMemo(() => {
    return getValueByKey(twoVal?.[1], "key", "receive")?.src;
  }, [twoVal]);

  const typeName = useMemo(() => {
    return stairInfo?.moduleJson?.visual?.visualData?.[0]?.typeName;
  }, [stairInfo]);

  const masterTitle = useMemo(() => {
    const result = enhancedSafeChainFind(stairInfo.moduleJsonData)?.base(
      "type",
      "configActivity",
    )?.val?.masterTitle;
    return result || stairInfo?.moduleJsonData?.base?.[1]?.val?.masterTitle;
  }, [stairInfo]);

  const currentProgressTextStyle = useMemo(() => {
    const fontStyle = getValueByKey(twoVal?.[3], "key", "fontStyle");
    return (
      enhancedSafeChainFind(fontStyle)?.options("accumulateCount")?.val
        ?.styleData || []
    );
  }, [twoVal]);

  const rewardDialogBgImg = useMemo(() => {
    const img = showDialogData.isSuccess
      ? oneVal[1][0].src
      : configTabs[configTabs.val][1][1].src;
    return processOssImage(img);
  }, [showDialogData.isSuccess, oneVal, configTabs]);

  // 进度条尺寸参数配置
  const progressBarConfig = useMemo(() => {
    const cardWidth = 220; // rem单位，对应px需要转换
    const arrowWidth = 28;

    // 节点尺寸
    const nodeSize = 30;

    // 单个进度条段的总宽度 = 图片宽度 + 箭头宽度
    const totalSegmentWidth = cardWidth + arrowWidth;

    // 连接线宽度 = 总段宽度 - 节点宽度
    const baseLineWidth = totalSegmentWidth - nodeSize;

    // 进度条高度
    const lineHeight = 12;

    return {
      nodeSize,
      lineHeight,
      baseLineWidth, // twoVal: 248-20=228, 正常: 196-20=176
      // 激活状态连接线宽度：基础宽度 + 节点尺寸的60%（视觉补偿）
      activeLineWidth: baseLineWidth + Math.floor(nodeSize * 0.6),
      // 调试信息
      cardWidth,
      arrowWidth,
      totalSegmentWidth,
    };
  }, [stairsStyle]);

  const prizeList = useMemo(() => {
    const result = enhancedSafeChainFind(stairInfo?.moduleJsonData)?.base(
      "type",
      "nodeList",
    )?.val;
    return result || stairInfo?.moduleJsonData?.base?.[3];
  }, [stairInfo]);

  // 活动类型（CC:单数，CP:度数）
  const activityType = useMemo(() => {
    console.log("prizeListprizeList", prizeList);
    return prizeList?.val?.[0]?.activityType;
  }, [prizeList]);

  // 打开弹窗
  const openRewardDialog = async (item, index, node_status, canClaim) => {
    trackGdp("P20189", "B004", {
      trackName: "充电_营销专题页_组件点击",
      origin: getChannel(),
      userType: "",
      versionId: stairInfo.versionCode,
      pageId: stairInfo.pageCode,
      ComponentCode: stairInfo.moduleId,
      type: stairInfo.moduleType,
      activityId: props.valCode,
      comp_style: typeName,
      status: "",
      clickLocation: `节点${item.sequence}`,
      node_status: node_status,
      max_node_completed: statusInfo.cumulateAmt,
    });
    if (isGuest) {
      await ensureLogin?.();
      return;
    }
    setTwoValDialogData({
      item,
      index,
      node_status,
      canClaim,
    });
    const prizeInfo = prizeList?.val?.[index];
    // 判断当前是否达到该节点的门槛
    const hasReachedThreshold = statusInfo.cumulateAmt >= item.achieveThreshold;
    setShowDialogData({
      isSuccess: hasReachedThreshold,
      prizeList: prizeInfo.prizeList,
    });
    setRewardDialogVisible(true);
  };

  // 领奖
  const receivePrizeData = async (
    item,
    index,
    node_status,
    dialog_visible = true,
  ) => {
    const prizeInfo = prizeList.val[index];
    trackGdp("P20189", "B004", {
      trackName: "充电_营销专题页_组件点击",
      origin: getChannel(),
      userType: "",
      versionId: stairInfo.versionCode,
      pageId: stairInfo.pageCode,
      ComponentCode: stairInfo.moduleId,
      type: stairInfo.moduleType,
      activityId: props.valCode,
      comp_style: typeName,
      status: "",
      clickLocation: `节点${item.sequence}`,
      node_status: node_status,
      max_node_completed: statusInfo.cumulateAmt,
    });
    if (isGuest) {
      await ensureLogin?.();
      return;
    }

    if (statusInfo.cumulateAmt >= item.achieveThreshold) {
      // 可领取
      if (item.canClaim) {
        // 待领取
        try {
          Loading.show("加载中...");
          const res = await receivePrize({
            activityId: props.valCode,
            nodeSequence: item.sequence,
            source: 1,
          });
          if (res.code == 200) {
            Toast.show({
              content: "领取成功",
              duration: 1000,
            });
            getDetail && getDetail();
            setShowDialogData({
              isSuccess: true,
              prizeList: prizeInfo.prizeList,
            });
            setRewardDialogVisible(dialog_visible);
          } else {
            Toast.show({
              content: res.msg,
            });
          }
        } catch (error: any) {
          console.log("error===", error);
        } finally {
          Loading.hide();
        }
      } else {
        if (prizeInfo.prizeList[0]?.prizeType === 4) {
          // 平台参与机会
          goToPageV2({ url: prizeInfo.jumpUrl });
        } else {
          // 已领取
          setShowDialogData({
            isSuccess: true,
            prizeList: prizeInfo.prizeList,
          });
          setRewardDialogVisible(dialog_visible);
        }
      }
    } else {
      // 不可领取
      setShowDialogData({
        isSuccess: false,
        prizeList: prizeInfo.prizeList,
      });
      setRewardDialogVisible(dialog_visible);
    }
  };

  const jumpDetail = () => {
    trackGdp("P20189", "B004", {
      trackName: "充电_营销专题页_组件点击",
      origin: getChannel(),
      userType: "",
      versionId: stairInfo.versionCode,
      pageId: stairInfo.pageCode,
      ComponentCode: stairInfo.moduleId,
      type: stairInfo.moduleType,
      activityId: props.valCode,
      comp_style: typeName,
      status: "",
      clickLocation: "活动详情",
    });
    if (isGuest) {
      ensureLogin?.();
      return;
    }
    goToPageV2({
      url: `${window.location.origin}/apps/charge-web/marketing.html#/detail?activityCode=${reActivity.val.valCode}`,
    });
  };

  // 风格2
  if (stairsStyle === "twoVal") {
    return (
      <div
        className={`stairs ${stairsStyle === "twoVal" ? "twoValStyle" : ""}`}
        style={{
          backgroundImage: `url(${processOssImage(rankBg2)})`,
          backgroundSize: "100% 100%",
          paddingLeft: stairInfo.moduleJsonData.paddingLeft,
          paddingRight: stairInfo.moduleJsonData.paddingRight,
        }}
      >
        <div className="sHeader twoValStyleHeader">
          <div className="sTitle" style={styleList2[0]?.styleObject}>
            {showConfig("masterTitle") && (
              <div className="sTitle1">{masterTitle}</div>
            )}
            {/* 活动详情 */}
            {showConfig("activityDetail") && (
              <div
                className="activityDetailBtn"
                style={{
                  backgroundImage: `url(${processOssImage(bgImg)})`,
                  right: stairInfo.moduleJsonData.paddingRight,
                }}
                onClick={() => jumpDetail()}
              />
            )}
          </div>
          <div className="sDesc" style={styleList2[1]?.styleObject}>
            {configActivity.val.assistantTitle}
          </div>
        </div>
        <div
          className="sContent"
          style={{
            textAlign: statusInfo.nodeList?.length <= 3 ? "center" : "left",
          }}
        >
          <div
            className="flex"
            style={{
              justifyContent:
                statusInfo.nodeList?.length <= 3 ? "center" : "unset",
            }}
          >
            {statusInfo.nodeList?.map((item, index) => {
              const { cumulateAmt } = statusInfo;
              let node_status = "不可领取";
              let showGifPic = stairInfo.moduleJsonData.staticImg?.find(
                (e) => e.lookupValueCode === "lw002",
              )?.lookupValueCn;
              if (cumulateAmt >= item.achieveThreshold) {
                // 待领取
                if (item.canClaim) {
                  node_status = "待领取";
                } else {
                  node_status = "已领取";
                  showGifPic = stairInfo.moduleJsonData.staticImg?.find(
                    (e) => e.lookupValueCode === "lw001",
                  )?.lookupValueCn;
                }
              } else {
                node_status = "不可领取";
              }
              const gifList = prizeList?.val.find(
                (i) => i.sequence == item.sequence,
              );
              if (gifList?.prizeList?.length == 1) {
                showGifPic = gifList.prizeList[0].prizeUrl;
              } else {
                showGifPic = multiplePrize;
              }
              return (
                <div className="nodeContainer">
                  <div
                    className="sCard"
                    key={item.sequence}
                    style={{
                      position: "relative",
                      backgroundImage: `url(${processOssImage(showGifPic)})`,
                      backgroundSize: "100% 100%",
                      height: "280rem",
                      width: `${progressBarConfig.cardWidth}rem`,
                      marginRight: 0,
                    }}
                    onClick={() =>
                      openRewardDialog(item, index, node_status, item.canClaim)
                    }
                  />
                  {cumulateAmt >= item.achieveThreshold && item.canClaim && (
                    <div
                      key={`${item.sequence}-claimableLabel`}
                      className="claimableLabel"
                      onClick={() =>
                        openRewardDialog(
                          item,
                          index,
                          node_status,
                          item.canClaim,
                        )
                      }
                    >
                      <div
                        className="receiveImgBtn"
                        style={{
                          backgroundImage: `url(${processOssImage(receiveImg)})`,
                          marginRight: `${progressBarConfig.arrowWidth / 2}rem`,
                        }}
                      />
                    </div>
                  )}
                  {index !== statusInfo.nodeList.length - 1 && (
                    <div
                      key={item.sequence}
                      className="arrowConnector"
                      style={{
                        backgroundImage: `url(${processOssImage(nodeArrow)})`,
                        width: `${progressBarConfig.arrowWidth}rem`,
                      }}
                    />
                  )}
                </div>
              );
            })}
          </div>
          {/* 渲染一共当前进度的占位文字 */}
          <div
            style={{
              marginTop: "8rem",
              visibility: "hidden",
            }}
          >
            <FontSetBox content={"1"} styleData={currentProgressTextStyle} />
          </div>
          {/* 进度条容器 */}
          <div className="progressContainer">
            {/* 进度条 */}
            <div className="customProgressBar">
              {statusInfo.nodeList?.map((item, index) => {
                const isCompleted =
                  statusInfo.cumulateAmt >= item.achieveThreshold;
                const currentIndex = statusInfo.nodeList.findIndex(
                  (e) => e.achieveThreshold === statusInfo.cumulateAmt,
                );

                // 节点颜色逻辑
                let nodeColor = uncompletedColor;
                if (isCompleted) {
                  nodeColor = completedColor;
                }

                // 连接线颜色逻辑：根据当前进度动态显示
                let lineColor = uncompletedColor;
                let lineProgress = 0; // 进度百分比

                if (index !== statusInfo.nodeList.length - 1) {
                  const nextThreshold =
                    statusInfo.nodeList[index + 1].achieveThreshold;
                  const currentThreshold = item.achieveThreshold;

                  if (statusInfo.cumulateAmt >= nextThreshold) {
                    // 已完成该段
                    lineColor = completedColor;
                    lineProgress = 100;
                  } else if (statusInfo.cumulateAmt >= currentThreshold) {
                    // 在该段进行中
                    lineProgress =
                      ((statusInfo.cumulateAmt - currentThreshold) /
                        (nextThreshold - currentThreshold)) *
                      100;
                    lineColor = completedColor;
                  }
                }

                // 计算连接线宽度
                const lineWidth =
                  item.canClaim &&
                  (index === currentIndex || index === currentIndex - 1)
                    ? progressBarConfig.activeLineWidth
                    : progressBarConfig.baseLineWidth;

                return (
                  <div
                    key={`progress-${item.sequence}`}
                    className="progressSegment"
                  >
                    {index === 0 && (
                      <div
                        className="initialProgressLine"
                        style={{
                          width: `${progressBarConfig.baseLineWidth / 2}rem`,
                          height: `${progressBarConfig.lineHeight}rem`,
                          backgroundColor: lineColor,
                        }}
                      ></div>
                    )}
                    {/* 节点容器 */}
                    <div
                      className="nodeContainer"
                      style={{ position: "relative" }}
                    >
                      {/* 节点 */}
                      <div
                        className="progressNode"
                        style={{
                          width: `${progressBarConfig.nodeSize}rem`,
                          height: `${progressBarConfig.nodeSize}rem`,
                          border: `${progressBarConfig.nodeSize / 4}rem solid ${nodeColor}`,
                        }}
                      ></div>

                      {/* 节点下方的目标值文本（绝对定位） */}
                      <div
                        className="nodeTargetText"
                        style={{
                          top: `${progressBarConfig.nodeSize + 8}rem`,
                          color: accumulateTipColor,
                        }}
                      >
                        充{item.achieveThreshold}
                        {activityType === "CC" ? "单" : "度"}
                      </div>

                      {/* 如果当前进度正好在这个节点上，显示进度指示器 */}
                      {statusInfo.cumulateAmt === item.achieveThreshold && (
                        <div
                          className="currentProgressIndicator"
                          style={{
                            backgroundColor: currentColor,
                            color: currentColor,
                            transform: `translateY(-100%) translateX(10px)`,
                          }}
                        >
                          <FontSetBox
                            content={`${statusInfo.cumulateAmt || 0}${activityType === "CC" ? "单" : "度"}`}
                            styleData={currentProgressTextStyle}
                          />
                        </div>
                      )}
                    </div>

                    {/* 连接线（除了最后一个节点） */}
                    {index !== statusInfo.nodeList.length - 1 && (
                      <div
                        className="progressLineContainer"
                        style={{
                          width: `${progressBarConfig.baseLineWidth}rem`,
                          height: `${progressBarConfig.lineHeight}rem`,
                          backgroundColor: uncompletedColor,
                        }}
                      >
                        {/* 进度条 */}
                        <div
                          className="progressFillLine"
                          style={{
                            width: `${lineProgress}%`,
                            borderRadius: `${lineProgress < 100 ? "0 4rem 4rem 0" : ""}`,
                            backgroundColor: lineColor,
                            position: "relative",
                          }}
                        >
                          {/* 如果当前进度在这个progressFillLine中，显示进度指示器 */}
                          {lineProgress > 0 &&
                            lineProgress < 100 &&
                            statusInfo.cumulateAmt > item.achieveThreshold &&
                            statusInfo.cumulateAmt <
                              statusInfo.nodeList[index + 1]
                                .achieveThreshold && (
                              <div
                                className="currentProgressIndicator"
                                style={{
                                  backgroundColor: currentColor,
                                  color: currentColor,
                                  top: "-10px",
                                }}
                              >
                                <FontSetBox
                                  content={`${statusInfo.cumulateAmt || 0}${activityType === "CC" ? "单" : "度"}`}
                                  styleData={currentProgressTextStyle}
                                />
                              </div>
                            )}
                        </div>
                      </div>
                    )}
                    {index === statusInfo.nodeList.length - 1 && (
                      <div
                        className="lastNodeSpacer"
                        style={{
                          width: `${lineWidth / 2}rem`,
                          height: `${progressBarConfig.lineHeight}rem`,
                        }}
                      ></div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* 领奖弹窗 */}
        <Dialog
          visible={rewardDialogVisible}
          onClose={() => setRewardDialogVisible(false)}
          getContainer={null}
          closeOnMaskClick
          bodyStyle={{ color: "red" }}
          bodyClassName="customDialogBody"
          content={
            <>
              <div
                className="twoValDialog"
                style={{
                  backgroundImage: `url(${processOssImage(showDialogData.isSuccess && twoValDialogData.canClaim ? jlcgtk001 : jlcktk001)})`,
                  backgroundSize: "100% 100%",
                  backgroundPosition: "center",
                }}
              >
                {/* 弹窗标题 */}

                {/* 奖品卡片区域 */}
                <div className="twoValPrizeGrid">
                  {showDialogData.prizeList.map((item, index) => {
                    return (
                      <div className="twoValPrizeCard" key={index}>
                        <img
                          src={processOssImage(item?.prizeUrl || "")}
                          className="twoValPrizeImage"
                        />
                      </div>
                    );
                  })}
                </div>
                <div
                  className="twoValButtonArea"
                  onClick={() =>
                    receivePrizeData(
                      twoValDialogData.item,
                      twoValDialogData.index,
                      twoValDialogData.node_status,
                      false,
                    )
                  }
                />
              </div>
            </>
          }
        ></Dialog>
      </div>
    );
  }

  return (
    <div
      className="stairs"
      style={{
        backgroundImage: `url(${processOssImage(stairImgMap.bj001?.src || "")})`,
        backgroundSize: "100% 100%",
        paddingLeft: stairInfo.moduleJsonData.paddingLeft,
        paddingRight: stairInfo.moduleJsonData.paddingRight,
      }}
    >
      <div className="sHeader">
        <div className="sTitle" style={styleList[0]?.styleObject}>
          <div className="sTitle1">{masterTitle}</div>
          <div
            className="details"
            style={styleList[2]?.styleObject}
            onClick={() => jumpDetail()}
          >
            活动详情
            <img src={icon_right} />
          </div>
        </div>
        <div className="sDesc" style={styleList[1]?.styleObject}>
          {configActivity.val.assistantTitle}
        </div>
      </div>
      <div
        className="sContent"
        style={{
          textAlign: statusInfo.nodeList?.length <= 3 ? "center" : "left",
        }}
      >
        <div
          className="flex"
          style={{
            justifyContent:
              statusInfo.nodeList?.length <= 3 ? "center" : "unset",
          }}
        >
          {statusInfo.nodeList?.map((item, index) => {
            const { cumulateAmt } = statusInfo;
            let showCardPic = stairImgMap.wjs001?.src; // 不可领取
            let node_status = "不可领取";
            let showGifPic = stairInfo.moduleJsonData.staticImg?.find(
              (e) => e.lookupValueCode === "lw002",
            )?.lookupValueCn;
            const currentIndex = statusInfo.nodeList.findIndex(
              (e) => e.achieveThreshold === cumulateAmt,
            );
            if (cumulateAmt >= item.achieveThreshold) {
              // 当前节点是否可领取
              // 待领取
              if (item.canClaim) {
                if (index === currentIndex) {
                  showCardPic = stairImgMap.dlqd001?.src; // 待领取 大
                } else {
                  showCardPic = stairImgMap.dlqx001?.src; // 待领取 小
                }
                node_status = "待领取";
              } else {
                node_status = "已领取";
                showCardPic = stairImgMap.ylq001?.src; // 已领取
                showGifPic = stairInfo.moduleJsonData.staticImg?.find(
                  (e) => e.lookupValueCode === "lw001",
                )?.lookupValueCn;
              }
            } else {
              node_status = "不可领取";
              showCardPic = stairImgMap.wjs001?.src; // 不可领取
            }
            let gifList = prizeList?.val.find(
              (i) => i.sequence == item.sequence,
            );
            if (gifList?.prizeList?.length == 1) {
              showGifPic = gifList.prizeList[0].prizeUrl;
            }
            return (
              <div
                className="sCard"
                key={item.sequence}
                style={{
                  backgroundImage: `url(${processOssImage(showCardPic)})`,
                  backgroundSize: "100% 100%",
                  height:
                    index === currentIndex && item.canClaim
                      ? "226rem"
                      : "196rem",
                  width:
                    index === currentIndex && item.canClaim
                      ? "200rem"
                      : "176rem",
                }}
                onClick={() => receivePrizeData(item, index, node_status)}
              >
                <div>
                  <img
                    className="prizeImg"
                    src={processOssImage(showGifPic)}
                  ></img>
                </div>
                <div className="task">
                  完成
                  {index === 0 &&
                  activityType === "CC" &&
                  item.achieveThreshold == "1"
                    ? "首"
                    : item.achieveThreshold}
                  {activityType === "CC" ? "单" : "度"}领取
                </div>
              </div>
            );
          })}
        </div>
        <div className="dotLine">
          {statusInfo.nodeList?.map((item, index) => {
            const dotImg =
              statusInfo.cumulateAmt >= item.achieveThreshold
                ? stairImgMap.ywcjd001?.src
                : stairImgMap.wwcjd001?.src; // 是否已领取
            const lineImg =
              statusInfo.cumulateAmt > item.achieveThreshold
                ? stairImgMap.jdtywc001?.src
                : stairImgMap.jdtwwc001?.src; // 是否已领取
            const currentIndex = statusInfo.nodeList.findIndex(
              (e) => e.achieveThreshold === statusInfo.cumulateAmt,
            );
            return (
              <>
                <img
                  src={processOssImage(dotImg)}
                  className="dot"
                  key={`dot-${item.sequence}`}
                ></img>
                {index != statusInfo.nodeList?.length - 1 && (
                  <img
                    src={processOssImage(lineImg)}
                    className="line"
                    key={`line-${item.sequence}`}
                    style={{
                      width:
                        item.canClaim &&
                        (index === currentIndex || index === currentIndex - 1)
                          ? "188rem"
                          : "173rem",
                    }}
                  />
                )}
              </>
            );
          })}
        </div>
      </div>
      {!!statusInfo.nodeList?.length && (
        <div
          className="sFooter"
          style={{
            backgroundImage: `url(${processOssImage(stairImgMap.wclj001?.src)})`,
            backgroundSize: "100% 100%",
          }}
        >
          {statusInfo.cumulateAmt ===
          statusInfo.nodeList[statusInfo.nodeList.length - 1]
            .achieveThreshold ? (
            <>
              <img
                className="success"
                src={processOssImage(stairImgMap.ywcjd001?.src)}
              />{" "}
              <span className="red">已全部达成</span>
            </>
          ) : (
            <>
              <span style={styleList[3]?.styleObject}>已累计</span>
              <span className="red" style={styleList[5]?.styleObject}>
                <span className="big">{statusInfo.cumulateAmt || 0}</span>
              </span>
              <span className="red" style={styleList[4]?.styleObject}>
                {activityType === "CC" ? "单" : "度"}
              </span>
            </>
          )}
        </div>
      )}
      {/* 中奖弹窗 */}
      <Dialog
        visible={rewardDialogVisible}
        onClose={() => setRewardDialogVisible(false)}
        getContainer={null}
        closeOnMaskClick
        bodyStyle={{ color: "red" }}
        bodyClassName="customDialogBody"
        content={
          <>
            <div
              className="rewardDialog"
              style={{
                backgroundImage: `url(${rewardDialogBgImg})`,
              }}
            >
              <div className="resultText"></div>
              <div
                className={`prizeList ${
                  showDialogData.prizeList?.length <= 3
                    ? "flexLayout"
                    : "webkitBoxLayout"
                }`}
              >
                {showDialogData.prizeList.map((item, index) => {
                  return (
                    <div className="prize normalPrizeBorder" key={index}>
                      <img src={processOssImage(item.prizeUrl)} />
                      <span className="text">{item.prizeName}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          </>
        }
      ></Dialog>
    </div>
  );
};

export default Stairs;
